export default [
  {
    path: "",
    redirect: "general",
  },
  {
    path: "general",
    component: () => import("@/views/settings/General.vue"),
    meta: {
      title: "Základní nastavení",
    },
  },
  {
    path: "password",
    component: () => import("@/views/settings/Password.vue"),
    meta: {
      title: "Změna hesla",
    },
  },
  {
    path: "facebook",
    component: () => import("@/views/settings/Facebook.vue"),
    meta: {
      title: "Propojení s Facebookem",
    },
  },
  {
    path: "billing",
    component: () => import("@/views/settings/Billing.vue"),
    meta: {
      title: "Platební údaje",
    },
  },
]
